import axios from "axios";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Plus } from "../assets/feathericons/plus.svg";

import CardForm from "../components/CardForm";

const Home = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // fetch all my forms
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://tellmemore-mahe.herokuapp.com/`
        );
        setData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, []);

  return isLoading ? (
    <div>en cours de chargement...</div>
  ) : (
    <div className="margin100 home">
      <h1>Mes formulaires</h1>

      <div className="cards">
        {/* ADD FORM */}
        <Link to="/form/add">
          <div className="card newform">
            <Plus className="plus" />
            <div>Nouveau formulaire</div>
          </div>
        </Link>

        {/* ALL FORMS */}
        {data.map((elem) => {
          return <CardForm data={elem} setData={setData} key={elem._id} />;
        })}
      </div>
    </div>
  );
};

export default Home;
